// LIKE·ILIKE 에 사용자 값을 넣을 때 — 이메일의 `_`(아무 글자 하나)·`%`(아무 글자 여럿)·`\`(이스케이프)는 글자 그대로로 바꾼다.
// PostgREST 는 like/ilike 값의 `*` 를 `%` 로 바꾸므로 `*` 는 글자 그대로 넣을 수 없다 → 한 글자 와일드카드 `_` 로 좁혀 넣고,
// 정확한 비교는 받은 뒤 sameOwnerEmail 로 한다(리뷰 53차 #1 · 54차 #2). channel."user" 처럼 대소문자가 섞인 칸을 대소문자 무시로 찾을 때 쓴다
export const likeLiteral = (value) => String(value ?? "").replace(/[\\%_]/g, (c) => "\\" + c).replace(/\*/g, "_");

// 저장된 주인(stored)이 이 이메일(input)인가 — 서버와 같은 규칙: 저장값은 대소문자만 무시(lower(c."user")), 입력은 앞뒤 공백도 무시(lower(btrim(p_email))).
// 저장값의 공백까지 무시하면 서버가 세지 않는 행을 화면만 센다(64차 #3 · 2026-10-10 실측 공백 섞인 저장값 0)
export const sameOwnerEmail = (stored, input) => String(stored ?? "").toLowerCase() === String(input ?? "").trim().toLowerCase();

// 주인 이메일로 ilike 할 때 — 입력의 앞뒤 공백을 먼저 뺀다(sameOwnerEmail·서버 btrim 과 같게). 공백이 남으면 DB 가 행을 먼저 걸러 비교가 소용없다(66차 #2)
export const ownerLike = (email) => likeLiteral(String(email ?? "").trim());
